define([
  'app',
  '../helpers/dropdown',
  'axios',
  'jquery'
], function (app, Dropdown, axios, $) {
  return app.Marionette.ItemView.extend({
    template: false,

    ui: {
      topicTypeButton: '.radio-box-button',
      subForumDropdown: '.editor__subject select',
      forumSelector: '.editor__subject',
      tagSelector: '[data-helper=input-tags]',
      notification: '.js-notification',
      submit: '.topic-create_submit button'
    },

    events: {
      'change @ui.topicTypeButton': 'onChangeTopicType',
      'submit @ui.submit': 'onSubmit',
      'click @ui.submit': 'onSubmit'
    },

    options: {
      type: 0,
      forumTree: []
    },

    /**
     *
     * @param options
     * @returns {exports}
     */
    initialize: function () {
      var dropdown = new Dropdown({ el: this.ui.subForumDropdown, create: false })

      this.subForumDropdown = dropdown.el.selectize
      this.currentType = this.getOption('type') || 0
      this.newsType = 3
      this.ideationType = 2
      this.previousType = null
      this.updateSubForumDropdown()

      return this
    },

    onSubmit: function (e) {
      if (!this.options.ideationV2 || this.currentType !== this.ideationType.toString()) {
        return
      }
      e.stopPropagation()
      e.preventDefault()
      var requestData = {
        'csrfToken': this.options.csrfToken,
        'sticky': false,
        'closed': false
      }
      var formData = $('form.js-wysiwyg-form').serializeArray()
      formData.forEach(({ name, value }) => {
        if (name === 'topic[title]') {
          requestData.title = value
        } else if (name === 'topic[firstPost][content]') {
          requestData.content = value
        } else if (name === 'topic[tags]') {
          requestData.tags = value.split(',').filter(val => val !== '')
        }
      })
      axios.defaults.headers.common = {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': this.options.csrfToken
      }
      this.ui.submit[0].classList.add('is-loading')

      axios.post('/community/api/ideas/submit', requestData)
        .then(function (data) {
          this.ui.submit[0].classList.remove('is-loading')
          var location = data.headers.location
          var id = location.split('/').pop()
          var ideaUrl = app.libs.topicUrlGenerator('ideas', requestData.title, id)
          window.location.assign(ideaUrl)
        }.bind(this))
        .catch(function () {
          this.ui.submit[0].classList.remove('is-loading')
          this.ui.notification[0].innerHTML = `<div class="box box__pad box--alert"><ul><li>${this.options.phrase}</li></ul></div>`
          this.ui.notification[0].scrollIntoView({ behavior: 'smooth', block: 'start' })
        }.bind(this))
    },

    /**
     *
     * @param newType
     * @returns {exports}
     */
    switchTopicType: function (newType) {
      this.previousType = this.currentType
      this.currentType = newType
      if (this.options.ideationV2 && this.currentType === this.ideationType.toString()) {
        this.ui.forumSelector.hide()
        if (!this.options.productAreas) {
          this.ui.tagSelector.hide()
        }
      } else {
        this.ui.forumSelector.show()
        this.ui.tagSelector.show()
      }

      this.updateSubForumDropdown()

      return this
    },

    /**
     *
     * @param e
     * @returns {exports}
     */
    onChangeTopicType: function (e) {
      this.ui.topicTypeButton.removeClass('is-active').filter(e.currentTarget).addClass('is-active')
      this.switchTopicType(e.target.value)

      return this
    },

    shouldIncludeCategory: function (forum) {
      if (parseInt(this.currentType, 10) === this.ideationType) {
        return app._.contains(forum.types, parseInt(this.currentType, 10))
      }

      return app._.intersection(forum.types, [parseInt(this.currentType, 10), this.newsType, 4, 5]).length > 0
    },

    /**
     *
     * @returns {exports}
     */
    updateSubForumDropdown: function () {
      var self = this
      var optionsList = this.options.forumTree
      var currentSelected = this.subForumDropdown.getValue()
      // Remove the current options
      this.subForumDropdown.options = {}
      this.subForumDropdown.clearOptionGroups()
      this.subForumDropdown.clearOptions()

      // Loop over all forums, find the
      app._.forEach(optionsList, function (category, categoryID) {
        categoryID = categoryID.toString()

        self.subForumDropdown.addOptionGroup(categoryID, { label: category.label })

        app._.forEach(category.subForums, function (forum, forumID) {
          if (self.shouldIncludeCategory(forum)) {
            self.subForumDropdown.addOption({ text: forum.label, value: forumID, optgroup: categoryID })
          }
        })
      })
      // Do not re-select the 'old' value when selecting ideation manually
      // If previousType is null, create topic in category view clicked, retain category selection for ideation
      if ((this.currentType === this.ideationType && this.previousType != null) || this.previousType === this.ideationType) {
        this.subForumDropdown.clear()
      } else {
      // Re-select the 'old' value when question or conversation
        this.subForumDropdown.setValue(currentSelected)
      }

      return this
    }
  })
})
